import React, { useCallback, useEffect, useState } from "react";

import {
  createTeacherEstablishment,
  getTeacherEstablishments,
  updateTeacherEstablishment,
} from "../services/examsApi";

const emptyForm = { nom: "", adresse: "", sous_tutelle: "", logo: null };
const detail = (error, fallback) => error?.response?.data?.detail || error?.response?.data?.nom || fallback;

export default function TeacherEstablishments({ onBack, onChanged }) {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState(emptyForm);
  const [editingId, setEditingId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const load = useCallback(async () => {
    setLoading(true);
    try {
      setItems(await getTeacherEstablishments());
      setError("");
    } catch (requestError) {
      setError(detail(requestError, "Impossible de charger les établissements."));
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const reset = () => { setEditingId(null); setForm(emptyForm); };
  const edit = (item) => {
    setEditingId(item.id);
    setForm({ nom: item.nom, adresse: item.adresse || "", sous_tutelle: item.sous_tutelle || "", logo: null });
  };
  const change = (field, value) => setForm((current) => ({ ...current, [field]: value }));

  const submit = async (event) => {
    event.preventDefault();
    if (!form.nom.trim() || saving) return;
    setSaving(true);
    setError("");
    try {
      if (editingId) await updateTeacherEstablishment(editingId, form);
      else await createTeacherEstablishment(form);
      reset();
      await load();
      await onChanged?.();
    } catch (requestError) {
      setError(detail(requestError, "Impossible d’enregistrer l’établissement."));
    } finally {
      setSaving(false);
    }
  };

  return <main className="ql-teacher-main">
    <div className="ql-exam-toolbar">
      <button type="button" className="ql-exam-back" onClick={onBack}><i className="bi bi-arrow-left"></i> Dashboard</button>
      <div><span className="ql-teacher-eyebrow">Générateur</span><h1>Mes établissements</h1></div>
    </div>
    {error && <div className="alert alert-danger" role="alert">{error}</div>}
    <section className="ql-establishment-layout">
      <div className="ql-teacher-panel">
        {loading ? <p role="status">Chargement des établissements…</p> : items.length === 0 ? <p>Aucun établissement enregistré.</p> : (
          <div className="ql-establishment-grid">{items.map((item) => <article key={item.id}>
            {item.logo_url ? <img src={item.logo_url} alt="" /> : <i className="bi bi-building"></i>}
            <div><strong>{item.nom}</strong><p>{item.adresse || "Adresse non renseignée"}</p><small>{item.sous_tutelle}</small></div>
            <div className="ql-establishment-actions">
              {item.owned ? <button type="button" className="btn btn-outline-primary btn-sm" onClick={() => edit(item)}>Modifier</button> : <span className="badge text-bg-light">Établissement partagé</span>}
            </div>
          </article>)}</div>
        )}
      </div>
      <form className="ql-teacher-panel ql-establishment-form" onSubmit={submit}>
        <h2>{editingId ? "Modifier l’établissement" : "Ajouter un établissement"}</h2>
        <label>Nom de l’établissement *<input value={form.nom} maxLength={200} required onChange={(e) => change("nom", e.target.value)} /></label>
        <label>Adresse (optionnel)<input value={form.adresse} maxLength={300} onChange={(e) => change("adresse", e.target.value)} /></label>
        <label>Tutelle / Diocèse / Congrégation (optionnel)<input value={form.sous_tutelle} maxLength={200} onChange={(e) => change("sous_tutelle", e.target.value)} /></label>
        <label>Logo (optionnel)<input type="file" accept="image/*" onChange={(e) => change("logo", e.target.files?.[0] || null)} /></label>
        <div><button className="btn btn-primary" type="submit" disabled={saving || !form.nom.trim()}>{saving ? "Enregistrement…" : editingId ? "Enregistrer" : "Ajouter"}</button>{editingId && <button className="btn btn-outline-secondary" type="button" onClick={reset}>Annuler</button>}</div>
      </form>
    </section>
  </main>;
}
